export default __webpack_public_path__ + "static/media/gerpal3.29db1c2b.jpg";